import { render, staticRenderFns } from "./ValidateBrand.vue?vue&type=template&id=731a4eab"
import script from "./ValidateBrand.vue?vue&type=script&lang=ts"
export * from "./ValidateBrand.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports